import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Loader2, Download, Home } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function QRCodes() {
  const [qrHome, setQrHome] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchQRCode = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/qr/home`);
      setQrHome(res.data);
    } catch (error) {
      // QR fetch failed
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQRCode();
  }, [fetchQRCode]);

  const downloadQR = () => {
    if (qrHome) {
      const link = document.createElement('a');
      link.href = qrHome.qr_base64;
      link.download = 'anan-kitchen-qr.png';
      link.click();
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF6F0]">
        <Loader2 className="w-8 h-8 animate-spin text-[#E05D3A]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAF6F0] py-12" data-testid="qr-codes-page">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <Badge className="bg-[#E05D3A]/10 text-[#E05D3A] mb-4">Share</Badge>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#2C402E] mb-3" data-testid="qr-title">
            QR Code
          </h1>
          <p className="text-[#4A4A4A]">Scan to visit or download to print on leaflets and posters</p>
        </div>

        {qrHome && (
          <Card className="text-center" data-testid="qr-home-card">
            <CardHeader>
              <div className="w-12 h-12 rounded-xl bg-[#2C402E] text-white flex items-center justify-center mx-auto mb-2">
                <Home className="w-6 h-6" />
              </div>
              <CardTitle className="font-serif text-xl text-[#2C402E]">ANAN's Kitchen</CardTitle>
              <p className="text-sm text-[#4A4A4A]">{qrHome.url}</p>
            </CardHeader>
            <CardContent>
              <div className="bg-white rounded-2xl p-4 inline-block mb-4 shadow-sm">
                <img src={qrHome.qr_base64} alt="Homepage QR Code" className="w-48 h-48" data-testid="qr-home-image" />
              </div>
              <br />
              <Button
                onClick={downloadQR}
                className="bg-[#2C402E] hover:bg-[#1a2a1c]"
                data-testid="qr-home-download"
              >
                <Download className="w-4 h-4 mr-2" /> Download QR Code
              </Button>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
